import React, {useContext, useEffect, useMemo, useReducer, useRef, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Context} from '../index';
import OrderService from '../services/OrderService';
import MyButton from '../UI/MyButton/MyButton';
import Popup from "reactjs-popup";
import EntityList from "../components/EntityList";
import {toJS} from "mobx";
import {MaterialReactTable} from "material-react-table";
import {Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography} from '@mui/material';
import DemandService from "../services/DemandService";
import {observer} from 'mobx-react-lite';

const Start = observer(function Start() {
    const {store} = useContext(Context);
    const [entities, setEntities] = useState([]);
    const [order, setOrder] = useState([]);
    const [testDialogOpen, setTestDialogOpen] = useState(false);
    const [testDemandId, setTestDemandId] = useState('');
    const [orderId, setOrderId] = useState('');
    const [showWaitingList, setShowWaitingList] = useState(false);
    const [showScanPopup, setShowScanPopup] = useState(false);
    const [showOrderNumberDialog, setShowOrderNumberDialog] = useState(false);
    const [orderNumber, setOrderNumber] = useState('');
    const showScanPopupRef = useRef();
    showScanPopupRef.current = showScanPopup;
    const [showOrderList, setShowOrderList] = useState(false);
    // Диалог для processed-заказов (сборщик): заказ уже был в работе раньше -
    // даём выбор: открыть / на корректировку / отменить.
    const [processedDialogOpen, setProcessedDialogOpen] = useState(false);
    const [pendingProcessedOrder, setPendingProcessedOrder] = useState(null);
    const [correctionReason, setCorrectionReason] = useState('уже был в работе у сборщика');
    const [isCorrecting, setIsCorrecting] = useState(false);
    let [barcodeParts, setBarcodeParts] = useState('');
    const [barcode, setBarcode] = useState({});
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const navigate = useNavigate();
    const labelRef = useRef(null);

    useEffect(() => {
        if (store.positionKey === 'oilFiller') {
            navigate('/oil-filling', { replace: true });
        }
    }, [store.positionKey, navigate]);

    const pagination = {
        pageSize: 100
    }
    const columnsWithDemand = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Отгрузка',
                size: 200
            },
            {
                accessorKey: 'customerorderName',
                header: 'Заказ покупателя',
                size: 200
            },
            {
                accessorFn: (row) => {
                    if (row.created == null) {
                        return 'нет данных';
                    }

                    const RED_ZONE_ORDERS_DATE = new Date();

                    const orderDate = new Date(row.created);

                    const diffInMs = RED_ZONE_ORDERS_DATE - orderDate;
                    const diffInHours = diffInMs / (1000 * 60 * 60);
                    return diffInHours.toFixed(2);
                },
                id: 'created',
                header: 'Часов в работе',
                size: 200
            }
        ],
        [],
    );

    const columns = useMemo(
        () => {
            const baseColumns = [
                {
                    accessorKey: 'name',
                    header: 'Заказ покупателя',
                    size: 200
                },
                {
                    accessorFn: (row) => {
                        if (row.created == null) {
                            return 'нет данных';
                        }

                        const RED_ZONE_ORDERS_DATE = new Date();

                        const orderDate = new Date(row.created);

                        const diffInMs = RED_ZONE_ORDERS_DATE - orderDate;
                        const diffInHours = diffInMs / (1000 * 60 * 60);
                        return diffInHours.toFixed(2);
                    },
                    id: 'created',
                    header: 'Часов в работе',
                    size: 200
                }
            ];
            // Колонка «после корректировки» - только сборщику
            if (store.positionKey === 'assembler') {
                baseColumns.push({
                    accessorKey: 'afterCorrection',
                    header: 'Примечание',
                    size: 240,
                    Cell: ({cell}) => (cell.getValue() ? 'Заказ после корректировки' : '')
                });
            }
            return baseColumns;
        },
        [store.positionKey],
    );

    useEffect(() => {
        getAllEntities();
    }, [])


    let inputBuffer = [];
    const ignoredKeys = ['NumLock', 'Enter'];
    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === 'Enter' && showScanPopupRef?.current) {
                const newBarcode = parseScannedInput(inputBuffer.join(''))
                setBarcode({value: newBarcode});
                inputBuffer = [];

                if (newBarcode?.startsWith('o')) {
                    chooseOrder(newBarcode);
                }
                return;
            }

            if (!ignoredKeys.includes(e.key)) {
                inputBuffer.push(e.key);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    async function chooseOrder(orderNumber) {
        const order = await OrderService.getOrderByOrderNumber(orderNumber);
        setOrder(order.data);
        setShowOrderList(true);
    }

    async function handleGetOrderByName() {
        const trimmedOrderNumber = orderNumber.trim();

        if (!trimmedOrderNumber) {
            alert('Пожалуйста, введите номер заказа!');
            return;
        }

        if (!/^\d+$/.test(trimmedOrderNumber)) {
            alert('Номер заказа должен содержать только цифры!');
            return;
        }

        if (trimmedOrderNumber.length > 10) {
            alert('Слишком длинный номер заказа!');
            return;
        }

        const formattedOrderNumber = `o${trimmedOrderNumber}`;

        try {
            await chooseOrder(formattedOrderNumber);
            setShowOrderNumberDialog(false);
            setOrderNumber('');
        } catch (error) {
            if (error.response?.status === 404) {
                alert(`Заказ с номером ${trimmedOrderNumber} не найден!`);
            } else if (error.response?.status === 403) {
                alert('Нет доступа к заказу или он уже взят в работу!');
            } else {
                alert(`Ошибка при поиске заказа: ${error.response?.data?.message || error.message}`);
            }
        }
    }

    function parseScannedInput(input) {
        const matches = input.match(/Alt(\d+)/g);
        if (!matches) return input;

        return matches.map((code) => {
            const num = code.replace("Alt", "");
            return String.fromCharCode(parseInt(num));
        }).join('');
    }

    function isOrderInRedZone(orderDateStr) {
        if (orderDateStr == null) {
            return false;
        }

        const RED_ZONE_ORDERS_DATE = new Date();

        const orderDate = new Date(orderDateStr);

        const diffInMs = RED_ZONE_ORDERS_DATE - orderDate;
        const diffInHours = diffInMs / (1000 * 60 * 60);

        const res = diffInHours >= 24;
        return res
    }

    async function startToCollect() {
        await store.checkEntitiesInWork();

        const userDemandsInWork = toJS(store.entitiesInWork);
        const hasCurrent = userDemandsInWork.find(item => item.current === true);
        if (hasCurrent) {
            const url = `/demand/${hasCurrent.id}`;
            navigate(url);
            return;
        }

        const newDemand = await DemandService.getNewDemand().then(data => data.data);
        if (!newDemand) {
            alert('Нет отгрузок! Обратитесь к главному!')
            return;
        }

        userDemandsInWork.push(newDemand);
        store.setEntitiesInWork(userDemandsInWork);
        navigate(`/demand/${newDemand.id}`);
    }

    // Получить следующий заказ для сборщика. Если был уже обработан -
    // открыть диалог с 3 кнопками. isAutoRetry=true используется при рекурсии
    // после "На корректировку" чтобы не показывать alert "Нет заказов" каждый раз.
    async function startToCollectForAssembler(isAutoRetry = false) {
        try {
            const response = await OrderService.getNewOrder();
            const order = response?.data;
            if (!order) {
                if (!isAutoRetry) {
                    alert('Нет заказов! Обратитесь к главному!');
                }
                return;
            }
            if (order.wasProcessedBefore) {
                setPendingProcessedOrder(order);
                setCorrectionReason('уже был в работе у сборщика');
                setProcessedDialogOpen(true);
                return;
            }
            navigate(`/orders/${order.id}`);
        } catch (e) {
            if (!isAutoRetry) {
                alert(`Ошибка при получении заказа: ${e?.response?.data?.message || e?.message}`);
            }
        }
    }

    // Открыть processed-заказ (юзер принял предупреждение).
    const handleOpenProcessed = () => {
        const order = pendingProcessedOrder;
        setProcessedDialogOpen(false);
        setPendingProcessedOrder(null);
        if (order) {
            navigate(`/orders/${order.id}`);
        }
    };

    // Отменить processed-заказ: диалог закрывается, заказ остаётся
    // присвоенным сборщику (через _setOrderInWork в getNewOrder) - появится
    // в "Мои заказы".
    const handleCancelProcessed = () => {
        setProcessedDialogOpen(false);
        setPendingProcessedOrder(null);
    };

    // Отправить processed-заказ на корректировку: changeStatus в МС +
    // addToWaitingList (пометить в Redis как не-current) + auto-fetch следующего.
    const handleSendProcessedToCorrection = async () => {
        const order = pendingProcessedOrder;
        if (!order) return;
        setIsCorrecting(true);
        try {
            await OrderService.changeOrderStatus(order.id, 'Корректировки', correctionReason);
            await OrderService.moveOrderToWaitingList(order.id, 'correct', correctionReason);
            setProcessedDialogOpen(false);
            setPendingProcessedOrder(null);
            // Рекурсивно берём следующий - если он тоже processed, диалог
            // откроется снова; если null - молча остаёмся (это auto-retry).
            await startToCollectForAssembler(true);
        } catch (e) {
            alert(`Ошибка при отправке на корректировку: ${e?.response?.data?.message || e?.message}`);
        } finally {
            setIsCorrecting(false);
        }
    };

    async function handleShowMyOrders() {
        await store.checkEntitiesInWork();
        setShowWaitingList(true);
    }

    function handleEntityRemoved() {
        setShowWaitingList(true);
    }

    function handleLogout() {
        navigate('/login')
    }

    function handleAllOrders() {
        navigate('/orders')
    }

    function handleAllOrdersInWork() {
        navigate('/ordersinwork')
    }


    async function getAllEntities() {
        try {
            let response;
            if (store.positionKey === 'assembler') {
                response = await OrderService.getAllOrders();
            } else if (store.positionKey === 'packer') {
                response = await DemandService.getAllDemands();
            } else if (store.positionKey === 'receiver') {
                response = { data: [] };
            } else {
                response = await OrderService.getAllOrders();
            }
            setEntities(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Открыть диалог выбора тестовой отгрузки
    function openTestDialog() {
        setTestDialogOpen(true);
    }

    async function startTestDemand() {
        if (!testDemandId.trim()) {
            alert('Введите ID отгрузки!');
            return;
        }

        try {
            const response = await DemandService.getSpecificDemand(testDemandId);
            const testDemand = response.data.demand;

            await store.checkEntitiesInWork();
            const userDemandsInWork = toJS(store.entitiesInWork);
            userDemandsInWork.push(testDemand);
            store.setEntitiesInWork(userDemandsInWork);

            setTestDialogOpen(false);
            setTestDemandId('');

            navigate(`/demand/${testDemand.id}`);

        } catch (error) {
            if (error.response?.status === 409) {
                alert(error.response.data.message || 'Отгрузка уже в работе');
            } else if (error.response?.status === 404) {
                alert(`Отгрузка с ID ${testDemandId} не найдена`);
            } else {
                alert('Ошибка загрузки тестовой отгрузки: ' + error.message);
            }
        }
    }

    return (
        <div>
            {entities
                ?
                <div style={{display: "grid", width: "200px", gridTemplateColumns: "auto"}}>
                    <h3 id={'welcomeLabel'} ref={labelRef}>{`Добро пожаловать, ${store.user.email}!`}</h3>
                    {store.user.email !== "admin"
                        ?
                        <div style={{display: "grid", justifyContent: "center"}}>
                            {store.positionKey === 'packer' ?
                                <>
                                    <MyButton onClick={startToCollect}>Новый заказ</MyButton>
                                    <MyButton onClick={() => navigate('/chestnyznak-checker')} style={{width: '180px', textAlign: 'center', marginTop: '10px'}}>
                                        🏷️ Проверка кодов Честный ЗНАК
                                    </MyButton>
                                    {process.env.REACT_APP_ENV === 'development' && (
                                        <MyButton
                                            onClick={openTestDialog}
                                            style={{
                                                backgroundColor: '#ff9800',
                                                marginTop: '10px',
                                                color: 'white'
                                            }}
                                        >
                                            🧪 Тестовая отгрузка (с маркировкой)
                                        </MyButton>
                                    )}
                                </>
                                :
                                ""}

                            {store.positionKey === 'assembler' ?
                                <>
                                    <MyButton onClick={() => startToCollectForAssembler()}>Новый заказ</MyButton>
                                    <MyButton onClick={() => setShowScanPopup(true)}>Отсканировать заказ</MyButton>
                                    <MyButton onClick={() => setShowOrderNumberDialog(true)}>Получить заказ по номеру</MyButton>
                                    <MyButton onClick={() => navigate('/chestnyznak-checker')} style={{width: '180px', textAlign: 'center', marginTop: '10px'}}>
                                        🏷️ Проверка кодов Честный ЗНАК
                                    </MyButton>
                                </>
                                :
                                ""}

                            {store.positionKey === 'receiver' ?
                                <>
                                    <MyButton onClick={() => navigate('/receipts')} style={{width: '180px', textAlign: 'center'}}>Модуль приемки</MyButton>
                                    <MyButton onClick={() => navigate('/chestnyznak-checker')} style={{width: '180px', textAlign: 'center', marginTop: '10px'}}>
                                        🏷️ Проверка кодов Честный ЗНАК
                                    </MyButton>
                                </>
                                :
                                ""}

                            {store.positionKey === 'oilFiller' && (
                                <div style={{ display: 'grid', justifyContent: 'center', padding: '20px' }}>
                                    <Typography>Перенаправление в модуль разлива...</Typography>
                                </div>
                            )}

                            {store.positionKey !== 'receiver' && (
                                <MyButton onClick={handleShowMyOrders}>Мои заказы</MyButton>
                            )}
                            {store.positionKey !== 'receiver' && (
                                <div>
                                    <h3>Список текущих заказов</h3>
                                    {entities
                                        ?
                                        <MaterialReactTable columns={store.positionKey === 'packer' ? columnsWithDemand : columns} data={entities}
                                                            initialState={{pagination}}
                                                            muiTableBodyRowProps={({row}) => ({
                                                                sx: {
                                                                    backgroundColor: isOrderInRedZone(row.original.created) ? '#f14545' : '#ffffff',
                                                                },
                                                            })}
                                                            renderTopToolbarCustomActions={() => {}}
                                        />
                                        :
                                        ""
                                    }
                                </div>
                            )}
                        </div>
                        :
                        ""

                    }
                    {/* Списки в попапах бывают длинными (накопившиеся заказы).
                        reactjs-popup по умолчанию не даёт контенту скроллиться:
                        контент выше вьюпорта обрезается, нижние пункты недостижимы.
                        contentStyle с overflow-y/max-height чинит это. */}
                    <Popup open={showWaitingList} onClose={() => setShowWaitingList(false)} modal
                           contentStyle={{overflowY: 'auto', maxHeight: '85vh'}}> <EntityList
                        entities={store.entitiesInWork}
                        title="Список заказов в ожидании"
                        onEntityRemoved={handleEntityRemoved}/> </Popup>

                    <Popup open={showScanPopup} onClose={() => setShowScanPopup(false)} modal>
                        <h3>Отсканируйте штрихкод</h3>
                    </Popup>

                    <Popup open={showOrderList} onClose={() => setShowOrderList(false)} modal
                           contentStyle={{overflowY: 'auto', maxHeight: '85vh'}}> <EntityList
                        entities={order}
                        title="Выберите заказ"/> </Popup>

                    {store.user.email === "admin"
                        ?
                        <div>
                            <MyButton onClick={handleAllOrders}>
                                Все заказы для сборки
                            </MyButton>
                            <MyButton onClick={handleAllOrdersInWork}>
                                Все заказы на сборке
                            </MyButton>
                        </div>
                        :
                        ""
                    }
                    <MyButton onClick={async () => {
                        await store.logout();
                        handleLogout();
                    }} style={{width: '180px', textAlign: 'center'}}>
                        Выйти
                    </MyButton>
                </div>
                :
                <div></div>
            }

            {/* Диалог для ввода номера заказа */}
            <Dialog open={showOrderNumberDialog} onClose={() => {
                setShowOrderNumberDialog(false);
                setOrderNumber('');
            }}>
                <DialogTitle>Получить заказ по номеру</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Номер заказа"
                        placeholder="Например: 12345"
                        fullWidth
                        variant="outlined"
                        value={orderNumber}
                        onChange={(e) => setOrderNumber(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleGetOrderByName();
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowOrderNumberDialog(false);
                        setOrderNumber('');
                    }}>Отмена</Button>
                    <Button onClick={handleGetOrderByName} variant="contained">Получить заказ</Button>
                </DialogActions>
            </Dialog>

            {/* Диалог для ввода ID тестовой отгрузки */}
            <Dialog open={testDialogOpen} onClose={() => setTestDialogOpen(false)}>
                <DialogTitle>Тестовая отгрузка с маркировкой</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="ID отгрузки"
                        placeholder="Например: d1d643de-744f-11f0-0a80-19eb000e30da"
                        fullWidth
                        variant="outlined"
                        value={testDemandId}
                        onChange={(e) => setTestDemandId(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                startTestDemand();
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTestDialogOpen(false)}>Отмена</Button>
                    <Button onClick={startTestDemand} variant="contained">Открыть отгрузку</Button>
                </DialogActions>
            </Dialog>

            {/* Заказ был в работе раньше: предупреждение сборщику.
                Два явных варианта: открыть и собрать повторно (юзер уверен что
                надо), или на корректировку (уходит менеджеру с дефолтной причиной).
                Закрытие по X/ESC (handleCancelProcessed) - "soft cancel": заказ
                остаётся присвоенным через _setOrderInWork, попадёт в "Мои заказы". */}
            <Dialog open={processedDialogOpen} onClose={isCorrecting ? undefined : handleCancelProcessed} maxWidth="xs" fullWidth>
                <DialogTitle>Заказ уже был в работе</DialogTitle>
                <DialogContent>
                    <Typography sx={{ mb: 2 }}>
                        Заказ <strong>{pendingProcessedOrder?.name}</strong> раньше
                        уже брали в работу. Что делаем?
                    </Typography>
                    <TextField
                        label="Причина корректировки (если отправляем)"
                        value={correctionReason}
                        onChange={(e) => setCorrectionReason(e.target.value)}
                        fullWidth
                        size="small"
                        disabled={isCorrecting}
                        helperText="Можно отредактировать перед отправкой"
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button onClick={handleOpenProcessed} color="success" disabled={isCorrecting}>
                        Открыть и собрать повторно
                    </Button>
                    <Button onClick={handleSendProcessedToCorrection} variant="contained" color="primary" disabled={isCorrecting}>
                        {isCorrecting ? 'Отправляем...' : 'На корректировку'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
});

export default Start;